<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
      <button class="absolute top-2 right-2 text-gray-500 hover:text-black" @click="$emit('close')">
        &times;
      </button>
      <div v-if="mode === 'sick'">
        <h2 class="text-xl font-bold mb-4">{{ $t('Krankmeldung') }}</h2>
        <label class="block mb-2">{{ $t('Datum') }}</label>
        <input type="date" v-model="form.date" class="mb-4 w-full border rounded p-2" />
        <label class="block mb-2">{{ $t('Kommentar (optional)') }}</label>
        <textarea v-model="form.reason" class="mb-4 w-full border rounded p-2"></textarea>
        <span v-if="notSickToday" class="text-sm text-red-600 mb-1 block">
          {{ $t('Krankmeldungen sind nach 9:00 Uhr am selben Tag nicht mehr möglich.') }}
        </span>
        <button @click="submit('sick')" class="bg-primary text-white px-4 py-2 rounded" :disabled="notSickToday || form.date == ''" :class="{'opacity-50 cursor-not-allowed': notSickToday || form.date == ''}">{{ $t('Melden') }}</button>
      </div>
      <div v-else-if="mode === 'exception'">
        <h2 class="text-xl font-bold mb-4">{{ $t('Ausnahme') }}</h2>
        <label class="block mb-2">{{ $t('Datum') }} <span class="text-red-500">*</span></label>
        <input type="date" v-model="form.date" class="mb-2 w-full border rounded p-2" />
        <label class="block mb-2">{{ $t('Neue Abholzeit') }} <span class="text-red-500">*</span></label>
        <input type="time" v-model="form.newTime" class="mb-2 w-full border rounded p-2" />
        <label class="block mb-2">{{ $t('Grund') }} <span class="text-red-500">*</span></label>
        <textarea v-model="form.reason" class="mb-4 w-full border rounded p-2"></textarea>
        <button :disabled="!form.date || !form.newTime || !form.reason" :class="['bg-primary text-white px-4 py-2 rounded', (!form.date || !form.newTime || !form.reason) ? 'opacity-50 cursor-not-allowed' : '']" @click="submit('exception')">{{ $t('Anfragen') }}</button>
      </div>
      <div v-else-if="mode === 'timeChange'">
        <h2 class="text-xl font-bold mb-4">{{ $t('Abholzeit ändern') }}</h2>
        <label class="block mb-2">{{ $t('Wochentag') }}</label>
        <select v-model="form.weekday" class="mb-4 w-full border rounded p-2">
          <option v-for="day in weekdays" :key="day" :value="day">{{ day }}</option>
        </select>
        <label class="block mb-2">{{ $t('Neue Abholzeit') }}</label>
        <input type="time" v-model="form.newTime" class="mb-4 w-full border rounded p-2" />
        <label class="block mb-2">{{ $t('Grund') }}</label>
        <textarea v-model="form.reason" class="mb-4 w-full border rounded p-2"></textarea>
        <button @click="submit('timeChange')" class="bg-primary text-white px-4 py-2 rounded">{{ $t('Ändern') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/API';
export default {
  name: "ChangePickupModal",
  props: {
    show: Boolean,
    mode: String,
    contract: Object,
  },
  data() {
    return {
      form: {
        date: '',
        comment: '',
        reason: '',
        weekday: '',
        newTime: '',
      },
      weekdays: [
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
      ],
    };
  },
  computed: {
    notSickToday() {
      const now = new Date();
      if(this.form.date != new Date().toISOString().split('T')[0]) return false;
      return now.getHours() > 8 || (now.getHours() === 9 && now.getMinutes() > 0);
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.form = { date: '', comment: '', reason: '', weekday: '', newTime: '' };
      }
    },
  },
  methods: {
    submit(type) {
      // Only send expected fields for 'sick'
      API.requestPickupChange({
        contract: this.contract.id || this.contract,
        kind: type,
        date: this.form.date,
        reason: this.form.reason,
        newTime: this.form.newTime,
        weekday: this.form.weekday,
      }, (response, status) => {
        if (status === 200) {
          this.$emit('toast', this.$t('Anfrage gesendet!'), 'success');
          this.$emit('close');
        } else {
          this.$emit('toast', this.$t('Fehler beim Senden der Anfrage.'), 'error');
        }
      });
    },
  },
};
</script>

<style scoped>
.bg-primary {
  background-color: #2563eb;
}
</style>
